import { type ReactNode, useMemo, useState } from 'react';

import type { PanelComponent, TriggerContext } from './types';

export function usePanel(initialState?: ReactNode): {
	Panel: PanelComponent;
	trigger: TriggerContext;
} {
	const [panel, setPanel] = useState<ReactNode>(initialState);

	const Panel = useMemo<PanelComponent>(() => {
		const PanelComponent = () => panel ?? null;
		return PanelComponent;
	}, [panel]);

	const trigger = useMemo<TriggerContext>(
		() => ({
			setPanel: (panel: ReactNode) => setPanel(panel),
		}),
		[setPanel],
	);

	return useMemo(() => ({ Panel, trigger }), [Panel, trigger]);
}
